import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/class-operations', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/class-operations', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/class-operations/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/class-operations/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/class-operations/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getYear = (Options = {}) => {
  return httpClient
    .get('/api/v2/class-operation/row-academic-years')
    .then(response =>
      Promise.resolve({
        data: (response.data.data || []).map(item => ({
          ac_year_id: Number(item.value),
          ac_year: item.label,
          ac_status_id: Number(item.ac_status_id)
        }))
      })
    )
    .catch(error => Promise.reject(error.response ? error.response.data : error.data))
}
export const getSubProgram = (acp_id, Option = {}) => {
  return httpClient
    .get('/api/v2/class-operation/sub-programs', {
      params: acp_id ? { main_program_id: acp_id } : {}
    })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getTerm = (Options = {}) => {
  return httpClient
    .get('/api/v2/class-operation/row-academic-terms', Options)
    .then(response =>
      Promise.resolve({
        data: (response.data.data || []).map(item => ({
          ac_term_id: Number(item.value),
          term_name: item.term_name || item.label,
          ac_year_id: Number(item.ac_year_id || item.yearId),
          acps_id: Number(item.acps_id),
          ac_status_id: Number(item.ac_status_id)
        }))
      })
    )
    .catch(error => Promise.reject(error.response ? error.response.data : error.data))
}

//Get main and sub program by filter term
export const getMainAndSub = (acps_id, Options = {}) => {
  return Promise.all([
    httpClient.get('/api/v2/class-operation/main-programs'),
    httpClient.get('/api/v2/class-operation/sub-programs')
  ])
    .then(([mainProgramResponse, subProgramResponse]) => {
      const mainPrograms = mainProgramResponse.data.data || []
      const subPrograms = subProgramResponse.data.data || []
      const subProgram = subPrograms.find(
        item => Number(item.value) === Number(acps_id)
      )

      if (!subProgram) {
        return Promise.resolve({ data: [] })
      }

      const mainProgram = mainPrograms.find(
        item => Number(item.value) === Number(subProgram.acp_id)
      )

      return Promise.resolve({
        data: [
          {
            acps_id: Number(subProgram.value),
            acps_name_foreign: subProgram.label,
            main_program: mainProgram
              ? {
                  acp_id: Number(mainProgram.value),
                  acp_name_foreign: mainProgram.label
                }
              : null
          }
        ]
      })
    })
    .catch(error => Promise.reject(error.response ? error.response.data : error.data))
}

// Get level and grade base on sub promgram
export const getLevel = (acps_id, Options = {}) => {
  return httpClient
    .get('/api/v2/class-operation/levels', {
      params: { sub_program_id: acps_id }
    })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response ? error.response.data : error.data))
}

//Get teacher list
export const getTeacher = (Options = {}) => {
  return httpClient
    .get('/api/v2/class-operation/teachers')
    .then(response =>
      Promise.resolve({
        data: (response.data.data || []).map(item => {
          const names = String(item.label || '').trim().split(' ')
          return {
            teacher_id: item.value,
            fname_foreign: names.shift() || '',
            lname_foreign: names.join(' ')
          }
        })
      })
    )
    .catch(error => Promise.reject(error.response ? error.response.data : error.data))
}

// Get building list
export const getBuilding = (Options = {}) => {
  return Promise.all([
    httpClient.get('/api/v2/class-operation/buildings'),
    httpClient.get('/api/v2/class-operation/rooms')
  ])
    .then(([buildingResponse, roomResponse]) => {
      const rooms = roomResponse.data.data || []
      return Promise.resolve({
        data: (buildingResponse.data.data || []).map(building => ({
          building_id: building.value,
          building_name: building.label,
          rooms: rooms
            .filter(room => Number(room.buildingId) === Number(building.value))
            .map(room => ({
              room_id: room.value,
              room_name: room.label,
              building_id: room.buildingId
            }))
        }))
      })
    })
    .catch(error => Promise.reject(error.response ? error.response.data : error.data))
}

// Get study time
export const getStudyTime = (Options = {}) => {
  return httpClient
    .get('/api/v2/class-operation/study-times')
    .then(response =>
      Promise.resolve({
        data: (response.data.data || []).map(item => ({
          ac_st_id: item.value,
          study_time: item.label
        }))
      })
    )
    .catch(error => Promise.reject(error.response ? error.response.data : error.data))
}

// Get academic class category
export const getCategoryClass = (Options = {}) => {
  return httpClient
    .get('/api/v2/class-operation/class-categories')
    .then(response =>
      Promise.resolve({
        data: (response.data.data || []).map(item => ({
          ac_category_id: item.value,
          ac_category_name_native: item.ac_category_name_native,
          ac_category_name: item.ac_category_name || item.label
        }))
      })
    )
    .catch(error => Promise.reject(error.response ? error.response.data : error.data))
}

// Get list own class
export const getListClass = (Options = {}) => {
  return httpClient
    .get(
      `/api/class-operations?fields[academic_classes]=ac_year_id,ac_term_id,class_id,class_name&include=academic_year,academic_term&page=-1&allYear=1`
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.data))
}

// get class list allow student to swap class
export const getClassAllowSwap = (acps_id, Options = {}) => {
  return httpClient
    .get(
      `/api/class-operations?fields[academic_classes]=class_id,class_name,acps_id&filter[acps_id]=${acps_id}&page=-1`
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.data))
}

export const copyClass = data => {
  return httpClient
    .post('/api/class-operations/copy-class', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  get,
  find,
  store,
  update,
  destroy,
  getYear,
  getTerm,
  getMainAndSub,
  getLevel,
  getTeacher,
  getBuilding,
  getStudyTime,
  getCategoryClass,
  getListClass,
  getClassAllowSwap,
  copyClass,
  getSubProgram
}
